/* eslint-disable react-hooks/exhaustive-deps */
import { type FieldProps } from '@eliadmin/core/src/components/configurator/configurator-field';
import { ConfigurationRange } from '@eliadmin/core/src/components/configurator/fields/configurator-range';
import { ConfiguratorSelect } from '@eliadmin/core/src/components/configurator/fields/configurator-select';
import {
  useConfiguratorStore,
  useProformQuery,
  type FieldDataItem,
} from '@eliadmin/core/src/stores/configurator-store';
import { useMemo } from 'react';

export function ConfigurationOrnament({ fieldConfig }: FieldProps<'ornament'>) {
  const index = Number(fieldConfig.column.replace('user_m', ''));
  if (isNaN(index))
    throw new Error(
      `Invalid ornament field name, expected user_m<number> got ${fieldConfig.column}`,
    );

  const user_konf_id = useConfiguratorStore(s => s.user_konf_id);
  const confId = useProformQuery('GET_PRODUCT_CONF_ID', { user_konf_id });
  const productConf = useProformQuery('GET_PRODUCT_CONF_ID', { user_konf_id });

  // const [sCounter, setSCounter] = useState(0);
  // const [vCounter, setVCounter] = useState(0);

  const ornamentSelect = confId.data?.root.smako_conf.column[('user_m' + index) as 'user_m1'];

  const lastOrnamentWithValue = useMemo(() => {
    for (let i = 1; i < 10; i++) {
      const value = productConf.data?.root.smako_conf.column[('user_m' + i) as 'user_m1'];
      if (!value) return i - 1;
    }
    return 9;
  }, [productConf]);

  // const keyMain = `user_m${index}` as 'user_m1';
  // const keyS = `user_m${index}_s` as 'user_m1_x';
  // const keyV = `user_m${index}_v` as 'user_m1_y';

  // useEffect(() => {
  //   if (
  //     productConf.data?.root.smako_conf.column[keyS] &&
  //     productConf.data?.root.smako_conf.column[keyMain]
  //   ) {
  //     setSCounter(c => c + 1);
  //   }
  // }, [
  //   !productConf.data?.root.smako_conf.column[keyS],
  //   !productConf.data?.root.smako_conf.column[keyMain],
  // ]);

  // useEffect(() => {
  //   if (
  //     !productConf.data?.root.smako_conf.column[keyV] &&
  //     !productConf.data?.root.smako_conf.column[keyMain]
  //   ) {
  //     setVCounter(c => c + 1);
  //   }
  // }, [
  //   !productConf.data?.root.smako_conf.column[keyV],
  //   !productConf.data?.root.smako_conf.column[keyMain],
  // ]);

  return (
    <div className="flex w-full flex-col gap-2">
      {/* <ConfiguratorFieldLabel fieldConfig={fieldConfig} /> */}
      <div className="grid w-full grid-cols-1 gap-2 rounded-md border p-4 @lg:grid-cols-2 @2xl:grid-cols-3">
        <ConfiguratorSelect
          key={`user_m${index}`}
          field={{
            id: `user_m${index}`,
            type: 'select',
            getFieldData: options => {
              const item = options.productConf.root.smako_conf_ornament?.ornament;
              if (!item) return [];
              return (Array.isArray(item) ? item : [item]) as FieldDataItem[];
            },
            renderValueLabel: value => {
              if (!value) return '';
              return value.popis;
            },
          }}
          isClearable={lastOrnamentWithValue === index}
          fieldConfig={{
            column: `user_m${index}`,
            help: '',
            label: `Ornament ${index}`,
            must: '0',
          }}
        />
        <ConfiguratorSelect
          key={`user_m${index}_o`}
          field={{
            id: `user_m${index}_o`,
            type: 'select',
            getFieldData: options => {
              return [
                { kod: '0', popis: '0°' },
                { kod: '90', popis: '90°' },
                { kod: '180', popis: '180°' },
                { kod: '270', popis: '270°' },
              ] as FieldDataItem[];
            },
            renderValueLabel(value) {
              if (!value) return '';
              return value.popis;
            },
          }}
          fieldConfig={{
            column: `user_m${index}_o`,
            help: '',
            label: `Otočení ornamentu ${index} `,
            must: '0',
          }}
          isDisabled={!ornamentSelect}
        />
        <ConfigurationRange
          key={`user_m${index}_s`}
          field={{
            id: `user_m${index}_s`,
            type: 'range',
            variant: 'poloha',
          }}
          fieldConfig={{
            column: `user_m${index}_x`,
            help: '',
            label: `Umístění ornamentu ${index} M1`,
            must: '0',
          }}
          isDisabled={!ornamentSelect}
        />
        <ConfigurationRange
          key={`user_m${index}_v`}
          field={{
            id: `user_m${index}_v`,
            type: 'range',
            variant: 'poloha',
          }}
          fieldConfig={{
            column: `user_m${index}_y`,
            help: '',
            label: `Umístění ornamentu ${index} M2`,
            must: '0',
          }}
          isDisabled={!ornamentSelect}
        />
      </div>
    </div>
  );
}
